import { RefreshCw } from 'lucide-react'
import { useLayoutEffect, useRef } from 'react'

import { useVersionCheck } from '../lib/versionCheck'

const BANNER_HEIGHT_VAR = '--update-banner-h'

//: Aviso no intrusivo (decisión de producto, docs/PROMPT-CACHE-BUSTING.md):
//: nunca recarga sola — en una app donde alguien puede estar a mitad de
//: armar un bot o lanzar una corrida de la Matriz, una recarga automática
//: le corta lo que no llegó a guardar. Se queda visible hasta que el
//: usuario actualiza a propósito; sin botón de cerrar aparte, a propósito
//: — no molesta lo suficiente como para necesitar uno, y "posponerlo"
//: sería sólo esconder el aviso de una versión que sigue sin estar.
export function UpdateBanner() {
  const updateAvailable = useVersionCheck()
  const ref = useRef<HTMLDivElement>(null)

  // El banner es `position: fixed` arriba de todo (ver .update-banner en
  // styles.css) — sidebar/topbar necesitan saber cuánto mide de verdad
  // para correrse hacia abajo y no quedar tapados. Un ResizeObserver, no
  // un número fijo: en una pantalla angosta el texto pasa a dos líneas y
  // el alto real cambia.
  useLayoutEffect(() => {
    const root = document.documentElement
    if (!updateAvailable) {
      root.style.setProperty(BANNER_HEIGHT_VAR, '0px')
      return
    }
    const element = ref.current
    if (!element) return

    const updateHeight = () => root.style.setProperty(BANNER_HEIGHT_VAR, `${element.offsetHeight}px`)
    updateHeight()
    const observer = new ResizeObserver(updateHeight)
    observer.observe(element)
    return () => {
      observer.disconnect()
      root.style.setProperty(BANNER_HEIGHT_VAR, '0px')
    }
  }, [updateAvailable])

  if (!updateAvailable) return null

  return (
    <div className="update-banner" role="status" ref={ref}>
      <span className="update-banner__message">
        <RefreshCw size={16} aria-hidden="true" />
        Hay una versión nueva de Deltabot disponible.
      </span>
      <button className="update-banner__button" onClick={() => window.location.reload()}>
        Actualizar
      </button>
    </div>
  )
}
